<template>
  <div class="refuseuser-box">

    <el-tabs v-model="userType" type="card" class="customer-tabs-mg" @tab-click="tabSelect">
      <el-tab-pane label="工程师" :name="'1'" :key="1"></el-tab-pane>
      <el-tab-pane label="服务站" :name="'2'" :key="2"></el-tab-pane>
    </el-tabs>

    <el-row class="row-bg">
      <!-- <el-col :span="24" style="text-align: left">
        <div style="line-height: 36px; font-size: 22px; font-weight: bold">
          拒单列表
        </div>
      </el-col> -->
      <el-form inline label-width="80px">
        <el-form-item label="状态：" label-width="70px">
          <el-select size="medium" placeholder="请选择状态" v-model="form.RefuseJobStatus"
            style="width: 160px; margin-right: 10px" @change="refuseStatusChange">
            <el-option :value="item.Value" :label="item.Name" v-for="(item, index) in refuseStatusArr"
              :key="index"></el-option>
          </el-select>
        </el-form-item> 
      </el-form>
    </el-row>

    <!-- 工程师 -->
    <el-table ref="userTable" v-if="userType == '1'" :stripe="true" :data="tableData" border
      style="width: 100%; margin-top: 10px" :header-cell-style="{ background: '#F5F7FA' }" v-loading="listLoading">
      <el-table-column label="用户ID" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.UserId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工程师姓名" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ (scope.row.UserId == 0 ? "[非平台用户] " : "") + scope.row.TrueName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单距离(km)" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.Distance || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员等级" show-overflow-tooltip width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.MemberCategoryName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所在省市" show-overflow-tooltip >
        <template slot-scope="scope">
          <span>{{ scope.row.FullAddress || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系方式" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.Handset || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="拒单数" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span @click="viewRefuseJob(scope.row)"
            style="width: 100%;height: 100%;display: block;text-decoration: underline;">{{ scope.row.IsRefuseJob
            }}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" fixed="right" width="200">
        <template slot-scope="scope">
           <el-button size="mini" v-if="scope.row.IsRefuseJob > 0" type="warning">已拒单</el-button>
          <el-button size="mini" v-else-if="scope.row.IsRefuseJob === 0&&scope.row.IsKill === 0" type="primary">未拒单</el-button>
          <el-button size="mini" v-else-if="scope.row.IsRefuseJob === 0&&scope.row.IsKill === 1" type="success">已承接</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--服务站 -->
    <el-table ref="companyTable" v-else :stripe="true" :data="tableData" style="width: 100%;margin-top: 10px"
      :header-cell-style="{ background: '#F5F7FA' }" border v-loading="listLoading">
      <el-table-column label="服务商ID" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyId || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务商名称" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="工单距离(km)" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.Distance || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所在省市" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.FullAddress || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务商联系人" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.LinkMan || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系方式" show-overflow-tooltip width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.HandSet || '--' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="拒单数" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span   @click="viewRefuseJob(scope.row)"
            style="width: 100%;height: 100%;display: block;text-decoration: underline;">{{
              scope.row.IsRefuseJob }}</span> 
        </template>
      </el-table-column>
      <el-table-column label="状态" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" v-if="scope.row.IsRefuseJob > 0" type="warning">已拒单</el-button>
          <el-button size="mini" v-else-if="scope.row.IsRefuseJob === 0&&scope.row.IsKill === 0" type="primary">未拒单</el-button>
          <el-button size="mini" v-else-if="scope.row.IsRefuseJob === 0&&scope.row.IsKill === 1" type="success">已承接</el-button>
        </template>
      </el-table-column>
    </el-table>


    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper" :page-size="form.pageSize" :total="total">
        </el-pagination>
      </div>
    </div>

    <JobRefuseList :userName="'工程师【' + viewRefuseUserName + '】'" ref="jobRefuse" />
  </div>
</template>
<script>
import {
  getJobRefuseUserList, //获取工程师列表
  getJobRefuseCompanyList //获取服务站列表
} from "@/service/job";
import JobRefuseList from './jobRefuseList';

export default {
  components: {
    JobRefuseList,
  },
  data() {
    return {
      listLoading: false,

      form: {
        PageNum: 1,
        PageSize: 10,
        RefuseJobStatus: 0, // 状态，0全部，1已拒单，2未拒单，3已承接
      },
      oraginForm: {},


      tableData: [],
      refuseStatusArr: [{ Name: "全部", Value: 0 }, { Name: "已拒单", Value: 1 }, { Name: "未拒单", Value: 2 }, { Name: "已承接", Value: 3 }],
      total: 0,
      jobId: 0,
      viewRefuseUserName: '',

      userType: "1", //1工程师，2服务站
    };
  },

  created() {
    // console.log('secondProductList:'+JSON.stringify(this.secondProductList));
    // console.log('brandListL:'+JSON.stringify(this.brandList));
    this.oraginForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    open(jobId) {
      this.jobId = jobId;
      this.tableData = [];
      this.handleReset();
    },

    // 查询
    handleSearch() {
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form = JSON.parse(JSON.stringify(this.oraginForm));

      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.pageNum = 1;
      this.form.pageSize = val;
      this.getRefuseData();
    },
    handleCurrentChange(val) {
      // console.log("handleCurrentChange listLoading:" + this.listLoading);

      if (this.listLoading) return;
      this.form.pageNum = val;
      this.getRefuseData();
    },
    //获取拒单数据
    async getRefuseData() {
      this.listLoading = true;
      console.log("getRefuseData this.form:" + JSON.stringify(this.form));
      let data = JSON.parse(JSON.stringify(this.form));
      console.log(data)

      !data.RefuseJobStatus && delete data.RefuseJobStatus;

      data.JobId = this.jobId;
      // console.log("getRefuseData userType:" + this.userType);
      let res = this.userType == '1' ? await getJobRefuseUserList(data) : await getJobRefuseCompanyList(data);

      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }

      if (this.userType == '1') {
        this.tableData = res.Data.TeamUserModelList || [];
      } else {
        this.tableData = res.Data.CompanyModelList || [];
      }
      this.total = res.Data.TotalCount;
    },
    //tab切换
    tabSelect() {
      if (this.listLoading) {
        return this.$message.warning("稍等一下，正在加载数据中...");
      };
      console.log('userType:' + this.userType);
      this.handleReset();

      // var ref = this.userType == '1' ? 'userTable' : 'companyTable';
      // setTimeout(() => {
      //   this.$refs[ref].doLayout();
      // }, 100)
    },

    //查看拒单列表
    viewRefuseJob(row) {
      if (row.IsRefuseJob <= 0) {
        return this.$message.error('该' + (this.userType === '1' ? '工程师' : '服务站') + '暂无拒单');
      }
      row.JobId = this.jobId;
      this.$refs.jobRefuse.openDia(row);
      this.viewRefuseUserName =this.userType === '1' ? row.TrueName : row.CompanyName;
      this.$refs.jobRefuse.loadList();
    },
    //状态改变
    refuseStatusChange() {
      console.log("userType:" + this.userType);
      this.handleSearch();
    },

  }
};
</script>
<style lang="scss">
.refuseuser-box {
  // border: 1px solid red;
  padding: 16px;
  padding-top: 0px;

  .row-bg {
    padding: 10px 14px;
    background-color: #f9fafc;
  }

  .none {
    display: none;
  }

  .yellow-tips {
    background-color: rgb(253, 246, 236);
    color: #e6a23c;

    border-radius: 4px;
    opacity: 1;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    transition: opacity 0.2s;
    font-size: 16px;
    line-height: 18px;
    float: right;
    width: 900px;
  }

  span.tips {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

}
</style>